import moment from 'moment';
import {
  createColumnsV2Common,
  createV2CommonFilters,
} from '../../../../aspects/V2CommonFields';
import {
  createColumnsV2Desadvs,
  createV2DesadvFilters,
} from '../../../../aspects/V2DesadvFields';
import { CommonList } from '../../../../shared';

/**
 * Declare the additional columns to display (aspects)
 */
const columns: any[] = [
  ...createColumnsV2Desadvs(),
  ...createColumnsV2Common(),
];

/**
 * Specific filters for orders
 */
const additionalFilters: any[] = [
  ...createV2CommonFilters(),
  ...createV2DesadvFilters(),
];

/**
 * Order list component
 */
const DxV2DesadvList = (props) => {
  return (
    <CommonList
      title='dxMessages.invoices.title'
      {...props}
      columns={columns}
      additionalFilters={additionalFilters}
      filterDefaultValues={{
        ingestDateAfter: moment()
          .subtract(4, 'hours')
          .format('YYYY-MM-DDTHH:mm:ss.SSS[Z]'),
      }}
    />
  );
};

export default DxV2DesadvList;
